import moment from "moment";
import React, { Component } from "react";
import { Col, Row, Card, CardBody, Button, Label } from "reactstrap";
import TrackOrder from "./TrackOrder";
import * as Server from "../Server";
import Page from "../components/Page";
import PrintLabel from "./PrintLabel";
import config from "./../config/local";
import PageSpinner from "../components/PageSpinner";
import NotificationSystem from "react-notification-system";
import { capitalizeFirstLetter } from "../GeneralFunctions";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";
class OrderDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      trackOrderModel: false,
      printLabelModel: false,
      order: this.props.history.location.state,
    };
  }

  componentDidMount() {
    this.getOrderDetails();
  }

  getOrderDetails = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: `shop/order/detail?orderId=${this.state.order._id}`,
        method: "GET",
      });
      if (response) {
        this.setState({ showLoader: false, order: response.order });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  changeStatus = async (orderId, status) => {
    let data = {
      orderId,
      status,
      orderFor: "mall",
    };
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "shop/order/updateStatus",
        method: "POST",
        data: data,
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.getOrderDetails();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  toggleprintLabelModel = (event) => {
    if (event) event.preventDefault();
    this.setState({ printLabelModel: !this.state.printLabelModel });
  };

  toggleTrackOrderModel = (event) => {
    if (event) event.preventDefault();
    this.setState({ trackOrderModel: !this.state.trackOrderModel });
  };

  render() {
    return (
      <div>
        {this.state.printLabelModel ? (
          <PrintLabel
            printLabelModel={this.state.printLabelModel}
            toggleprintLabelModel={() => this.toggleprintLabelModel()}
            order={this.state.order}
          />
        ) : this.state.trackOrderModel ? (
          <TrackOrder
            order={this.state.order}
            trackOrderModel={this.state.trackOrderModel}
            toggleTrackOrderModel={() => this.toggleTrackOrderModel()}
          />
        ) : (
          <div>
            <PageSpinner showLoader={this.state.showLoader} />
            <Page
              title="Order-Details"
              breadcrumbs={[{ name: "Order-Details", active: true }]}
            >
              <Card>
                <CardBody>
                  <Row>
                    <Col xs={4}>
                      <p className="font-weight-bold m-0">Invoice Number:</p>
                    </Col>
                    <Col xs={6}>{this.state.order._id || "-"}</Col>
                    <Col xs={4}>
                      <p className="font-weight-bold m-0">Order Date:</p>
                    </Col>
                    <Col xs={6}>
                      {moment
                        .utc(this.state.order.createdAt || "-")
                        .format("MM-DD-YYYY")}
                    </Col>
                    <Col xs={4}>
                      <p className="font-weight-bold m-0">Status:</p>
                    </Col>
                    <Col xs={6}>
                      <span
                        style={{ backgroundColor: "#c7c5c5" }}
                        className=" p-1 rounded-lg text-center"
                      >
                        {capitalizeFirstLetter(
                          this.state.order.items[0].status || "-"
                        )}
                      </span>
                    </Col>
                    <Col xs={4}>
                      <p className="font-weight-bold m-0">Shipping Method:</p>
                    </Col>
                    <Col xs={6}>
                      {typeof this.state.order.items[0].shipping === "object"
                        ? this.state.order.items[0].shipping.Service
                        : "-"}
                    </Col>
                    <Col xs={4}>
                      <p className="font-weight-bold m-0">Resi Number:</p>
                    </Col>
                    <Col xs={6}>{this.state.order.items[0].refno || "-"}</Col>
                  </Row>
                  <Row>
                    <Col xs={6}>
                      <Label className="font-weight-bold">
                        Product Ordered:-
                      </Label>
                      <Card>
                        {this.state.order.items.map((item, index) => (
                          <div
                            key={index}
                            className="d-flex m-2 p-1"
                            style={{ borderBottom: " 1px groove" }}
                          >
                            <div className="w-50">
                              <img
                                className="img-responsive img-rounded w-75"
                                alt=" "
                                src={`${config.imageBaseUrl}/${item.product.images[0]}`}
                              />
                            </div>
                            <div className=" m-2">
                              <p className="m-0">
                                {capitalizeFirstLetter(
                                  item.product.title || ""
                                )}
                              </p>
                              <p className="m-0">
                                {item.quantity}
                                {" " + "x "}
                                {item.price}
                              </p>
                              <p className="m-0">
                                Total:
                                {item.quantity * item.price}
                              </p>
                            </div>
                            <hr
                              className="m-0 p-0"
                              style={{ borderColor: "#17517b" }}
                            />
                          </div>
                        ))}
                      </Card>
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col xs={12}>
                      <p className="font-weight-bold">Buyer Details:-</p>
                    </Col>
                    <Col xs={4}>
                      <p className="font-weight-bold m-0">Name:</p>
                    </Col>
                    <Col xs={6}>
                      {capitalizeFirstLetter(
                        this.state.order.address[0].fullName || "-"
                      )}
                    </Col>
                    <Col xs={4}>
                      <p className="font-weight-bold m-0">Phone Number:</p>
                    </Col>
                    <Col xs={6}>{this.state.order.address[0].phone}</Col>
                    <Col xs={4}>
                      <p className="font-weight-bold m-0">Email:</p>
                    </Col>
                    <Col xs={6}>{this.state.order.address[0].email}</Col>
                    <Col xs={4}>
                      <p className="font-weight-bold m-0">Shipping Address:</p>
                    </Col>
                    <Col xs={6}>
                      {this.state.order.address.length > 0 ? (
                        <div>
                          <p className="m-0 p-0">
                            {this.state.order.address[0].address1 || ""}
                          </p>
                          <p className="m-0 p-0">
                            {this.state.order.address[0].address2 || ""}
                          </p>
                          <p className="m-0 p-0">
                            {this.state.order.address[0].postal || ""}
                          </p>
                        </div>
                      ) : (
                        "-"
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={1}>
                      <Button
                        className="m-2"
                        onClick={(event) => {
                          event.preventDefault();
                          this.props.history.push("/orders");
                        }}
                      >
                        Back
                      </Button>
                    </Col>
                    <Col>
                      {this.state.order.items[0].status === "new" ? (
                        <div className="float-right m-1">
                          <Button
                            className="m-2"
                            onClick={(event) =>
                              this.changeStatus(
                                this.state.order._id,
                                "on process"
                              )
                            }
                          >
                            Accept order
                          </Button>
                          <Button
                            className="m-2"
                            onClick={(event) =>
                              this.changeStatus(
                                this.state.order._id,
                                "cancelled"
                              )
                            }
                          >
                            Reject order
                          </Button>
                        </div>
                      ) : this.state.order.items[0].status === "on process" ? (
                        <div className="float-right m-1">
                          <Button
                            className="m-2"
                            onClick={(event) =>
                              this.toggleprintLabelModel(event)
                            }
                          >
                            Print Label
                          </Button>
                          <Button
                            className="m-2"
                            onClick={(event) =>
                              this.changeStatus(
                                this.state.order._id,
                                "on shipping"
                              )
                            }
                          >
                            Request pickup
                          </Button>
                          <Button
                            className="m-2"
                            onClick={(event) =>
                              this.changeStatus(
                                this.state.order._id,
                                "cancelled"
                              )
                            }
                          >
                            Reject order
                          </Button>
                        </div>
                      ) : ["on shipping", "arrived"].includes(
                          this.state.order.items[0].status
                        ) ? (
                        <div className="float-right m-1">
                          <Button
                            onClick={(event) =>
                              this.toggleTrackOrderModel(event)
                            }
                          >
                            Track
                          </Button>
                        </div>
                      ) : (
                        ""
                      )}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <NotificationSystem
                dismissible={false}
                ref={(notificationSystem) =>
                  (this.notificationSystem = notificationSystem)
                }
                style={NOTIFICATION_SYSTEM_STYLE}
              />
            </Page>
          </div>
        )}
      </div>
    );
  }
}

export default OrderDetail;
